<template>
  <div id="app" class="App.vue">
    <!--<img src="./assets/logo.png">-->
    <div class="container-fluid">
      <main-menu></main-menu>
      <transition name="customize"
                  :enter-active-class="transitionEnter"
                  :leave-active-class="transitionLeave"
      >
        <router-view/>
      </transition>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>

<script>
  import MainMenu from './components/MainMenu.vue'
  import loading from '../static/media/loading.svg'
  import Snap from 'snapsvg'

  export default {
    name: 'app',
    data() {
      return {
        transitionName: 'teste',
        transitionEnter: 'animated slideInRight',
        transitionLeave: 'animated slideOutLeft',
      }
    },
    beforeRouteEnter (to, from, next) {
      if (to.name !== 'Home' && !window.isDirty && to.name !== 'Error404'){
        next('/home');
      }else{
        next();
      }

    },
    beforeRouteUpdate(to, from, next) {

      if (
        (to.name === 'Home' && from.name !== 'Splash' && from.name !== 'ContactForm') ||
        (to.name === 'GuestType' && from.name === 'CandidateType') ||
        (to.name === 'CandidateType' && from.name === 'CandidatePosition') ||
        (to.name === 'CandidatePosition' && from.name === 'FormCandidate') ||
        (to.name === 'Overview' && from.name === 'BusinessStage') ||
        (to.name === 'BusinessStage' && from.name === 'Cart') ||
        (to.name === 'Cart' && from.name === 'Thanks') ||
        (to.name === 'Cart' && from.name === 'FormClient') ||
        (to.name === 'Splash' && from.name === 'Home')
        // || (to.name === 'GuestType' && from.name === 'Overview')
      ) {
        // left to right
        this.transitionEnter = 'animated slideInLeft';
        this.transitionLeave = 'animated slideOutRight';
      } else if (to.name === 'BusinessStage' && from.name === 'Overview') {
        this.transitionEnter = 'animated slideInRight';
        this.transitionLeave = 'animated fadeOut';
      } else if (to.name === 'Error404') {
        this.transitionEnter = 'animated fadeIn';
        this.transitionLeave = 'animated fadeOut';
      } else if (to.name === 'ContactForm') {
        this.transitionEnter = 'animated slideInDown';
        // this.transitionLeave = 'animated slideOutDown'
        this.transitionLeave = 'animated fadeOut'
      } else if (from.name === 'ContactForm') {
        this.transitionEnter = 'animated slideInUp';
        this.transitionLeave = 'animated slideOutUp';

      } else if (to.name === 'Overview' && from.name === 'GuestType'){
        this.transitionEnter = 'animated slideInUp';
        this.transitionLeave = 'animated slideOutUp';
      } else {
        // right to left

        this.transitionEnter = 'animated slideInRight';
        this.transitionLeave = 'animated slideOutLeft'
      }
      console.log('from: ' + from.name);
      console.log('to: ' + to.name);
      next()
    },
    components: {
      MainMenu,
      loading
    },
    mounted(){
      $('.loading').addClass('hideL');
    }

  }
</script>

<style lang="scss">
  @import 'scss/main';
</style>



// WEBPACK FOOTER //
// src/App.vue